var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBaselineBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-block"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM4 12.5C4 8.08 7.58 4.5 12 4.5C13.85 4.5 15.55 5.13 16.9 6.19L5.69 17.4C4.59163 16.0032 3.99623 14.2769 4 12.5ZM12 20.5C10.15 20.5 8.45 19.87 7.1 18.81L18.31 7.6C19.4084 8.99679 20.0038 10.7231 20 12.5C20 16.92 16.42 20.5 12 20.5Z",
    fill: "#DD1F4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBaselineBlock);
export default __webpack_public_path__ + "static/media/ic_baseline-block.ed07df98.svg";
export { ForwardRef as ReactComponent };